var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.625 25.7059C41.0062 25.7059 40.5 26.2088 40.5 26.8235V35.7647H2.25V26.8235C2.25 26.2088 1.74375 25.7059 1.125 25.7059C0.50625 25.7059 0 26.2088 0 26.8235V36.8824C0 37.4971 0.50625 38 1.125 38H41.625C42.2438 38 42.75 37.4971 42.75 36.8824V26.8235C42.75 26.2088 42.2438 25.7059 41.625 25.7059Z",
    fill: "url(#paint0_linear_142_633)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 32.11C20.6888 32.3112 20.97 32.4118 21.24 32.4118C21.2625 32.4118 21.285 32.4006 21.3188 32.4006C21.3413 32.4006 21.3638 32.4118 21.3863 32.4118C21.8363 32.4118 22.2188 32.1435 22.3988 31.7747L31.6463 23.5041C32.1075 23.0906 32.1413 22.3865 31.725 21.9282C31.3088 21.47 30.6 21.4365 30.1388 21.85L22.5113 28.6676V1.11765C22.5113 0.502941 22.005 0 21.3863 0C20.7675 0 20.2613 0.502941 20.2613 1.11765V28.8688L12.645 21.8612C12.195 21.4365 11.475 21.47 11.0588 21.9171C10.6313 22.3641 10.665 23.0794 11.115 23.4929L20.475 32.1212V32.11Z",
    fill: "url(#paint1_linear_142_633)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_633",
    x1: -21.3862,
    y1: 69.6518,
    x2: 36.3048,
    y2: 17.9872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_142_633",
    x1: -5.02874,
    y1: 39.5423,
    x2: 29.9237,
    y2: 8.24412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGradient);
export default __webpack_public_path__ + "static/media/download-gradient.696194d2d6f9b689d0e70d050859fd60.svg";
export { ForwardRef as ReactComponent };